import {
    MDBBreadcrumb, MDBBreadcrumbItem,
    MDBBtn,
    MDBIcon,
    MDBInput,
    MDBSelect,
    MDBTabs,
    MDBTabsContent,
    MDBTabsItem, MDBTabsLink,
    MDBTabsPane
} from 'mdb-react-ui-kit';
import React, { useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useTranslation } from "react-i18next";
import Body from "../components/body/BodyPage";
import syncIcon from "../components/images/RefreshIcon.svg";
import MainLinks from "../components/navlinks/MainLinks";
const data = [
    {
        id: "item-1",
        content: (
            <>
                <tr className="d-flex align-items-center justify-content-between w-100">
                    <td className="w-5"> <MDBIcon fas icon="grip-vertical" className="mx-2 fs-small" />1</td>
                    <td><MDBSelect
                        size="sm"
                        data={[
                            { text: 'One', value: 1 },
                            { text: 'Two', value: 2 },
                        ]}
                    /></td>
                    <td><MDBSelect
                        data={[
                            { text: 'One', value: 1 },
                            { text: 'Two', value: 2 },
                        ]}
                    /></td>
                    <td><MDBInput label='Example label' id='form1' type='text' /></td>
                    <td><MDBInput label='Example label' id='form1' type='text' /></td>
                    <td><MDBSelect
                        data={[
                            { text: 'One', value: 1 },
                            { text: 'Two', value: 2 },
                        ]}
                    /></td>
                    <td className="text-center w-5"><MDBIcon fas icon="times" color="primary" /></td>
                </tr>
            </>
        ),
    },
    {
        id: "item-2",
        content: (
            <>
                <tr className="d-flex align-items-center justify-content-between w-100">
                    <td colspan="7" className="w-100">
                        <table className="datatable table-responsive mt-0 table2 w-100">
                            <tr className="table2 w-100 d-flex align-items-center justify-content-between w-100 py-1 border-bottom-1">
                                <td className="w-5"><MDBIcon fas icon="grip-vertical" className="mx-2 fs-small" /> 2</td>
                                <td><MDBSelect
                                    data={[
                                        { text: 'One', value: 1 },
                                        { text: 'Two', value: 2 },
                                    ]}
                                /></td>
                                <td><MDBSelect
                                    data={[
                                        { text: 'One', value: 1 },
                                        { text: 'Two', value: 2 },
                                    ]}
                                /></td>
                                <td><MDBInput label='Example label' id='form1' type='text' /></td>
                                <td><MDBInput label='Example label' id='form1' type='text' /></td>
                                <td><MDBSelect
                                    data={[
                                        { text: 'One', value: 1 },
                                        { text: 'Two', value: 2 },
                                    ]}
                                /></td>
                                <td className="text-center w-5"><MDBIcon fas icon="times" color="primary" /></td>
                            </tr>
                            <tr className="table2 w-100 d-flex align-items-center justify-content-between w-100 py-1">
                                <td className="w-5"><MDBIcon fas icon="link" color="primary" className="me-2 ms-4 fs-small" />2a</td>
                                <td><MDBSelect
                                    data={[
                                        { text: 'One', value: 1 },
                                        { text: 'Two', value: 2 },
                                    ]}
                                /></td>
                                <td><MDBSelect
                                    data={[
                                        { text: 'One', value: 1 },
                                        { text: 'Two', value: 2 },
                                    ]}
                                /></td>
                                <td><MDBInput label='Example label' id='form1' type='text' /></td>
                                <td><MDBInput label='Example label' id='form1' type='text' /></td>
                                <td><MDBSelect
                                    data={[
                                        { text: 'One', value: 1 },
                                        { text: 'Two', value: 2 },
                                    ]}
                                /></td>
                                <td className="text-center w-5"><MDBIcon fas icon="times" color="primary" /></td>
                            </tr>
                            <tr className="table2 w-100 d-flex align-items-center justify-content-between w-100 py-1">
                                <td className="w-5"><MDBIcon fas icon="link" color="primary" className="me-2 ms-4 fs-small" />2b</td>
                                <td><MDBSelect
                                    data={[
                                        { text: 'One', value: 1 },
                                        { text: 'Two', value: 2 },
                                    ]}
                                /></td>
                                <td><MDBSelect
                                    data={[
                                        { text: 'One', value: 1 },
                                        { text: 'Two', value: 2 },
                                    ]}
                                /></td>
                                <td><MDBInput label='Example label' id='form1' type='text' /></td>
                                <td><MDBInput label='Example label' id='form1' type='text' /></td>
                                <td><MDBSelect
                                    data={[
                                        { text: 'One', value: 1 },
                                        { text: 'Two', value: 2 },
                                    ]}
                                /></td>
                                <td className="text-center w-5"><MDBIcon fas icon="times" color="primary" /></td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </>
        ),
    },
    {
        id: "item-3",
        content: (
            <>
                <>
                    <tr className="d-flex align-items-center justify-content-between w-100">
                        <td className="w-5"><MDBIcon fas icon="grip-vertical" className="mx-2 fs-small" /> 3</td>
                        <td><MDBSelect
                            data={[
                                { text: 'One', value: 1 },
                                { text: 'Two', value: 2 },
                            ]}
                        /></td>
                        <td><MDBSelect
                            data={[
                                { text: 'One', value: 1 },
                                { text: 'Two', value: 2 },
                            ]}
                        /></td>
                        <td><MDBInput label='Example label' id='form1' type='text' /></td>
                        <td><MDBInput label='Example label' id='form1' type='text' /></td>
                        <td><MDBSelect
                            data={[
                                { text: 'One', value: 1 },
                                { text: 'Two', value: 2 },
                            ]}
                        /></td>
                        <td className="text-center w-5"><MDBIcon fas icon="times" color="primary" /></td>
                    </tr>
                </>
            </>
        ),
    },
    {
        id: "item-4",
        content: (
            <>
                <>
                    <tr className="d-flex align-items-center justify-content-between w-100">
                        <td className="w-5"><MDBIcon fas icon="grip-vertical" className="mx-2 fs-small" />4</td>
                        <td><MDBSelect
                            data={[
                                { text: 'One', value: 1 },
                                { text: 'Two', value: 2 },
                            ]}
                        /></td>
                        <td><MDBSelect
                            data={[
                                { text: 'One', value: 1 },
                                { text: 'Two', value: 2 },
                            ]}
                        /></td>
                        <td><MDBInput label='Example label' id='form1' type='text' /></td>
                        <td><MDBInput label='Example label' id='form1' type='text' /></td>
                        <td><MDBSelect
                            data={[
                                { text: 'One', value: 1 },
                                { text: 'Two', value: 2 },
                            ]}
                        /></td>
                        <td className="text-center w-5"><MDBIcon fas icon="times" color="primary" /></td>
                    </tr>
                </>
            </>
        ),
    },
    {
        id: "item-5",
        content: (
            <>
                <tr className="d-flex align-items-center justify-content-between w-100">
                    <td colspan="7" className="w-100">
                        <table className="datatable table-responsive mt-0 table2 w-100">
                            <tr className="table2 w-100 d-flex align-items-center justify-content-between w-100 py-1">
                                <td className="w-5"> <MDBIcon fas icon="grip-vertical" className="mx-2 fs-small" />5</td>
                                <td><MDBSelect
                                    data={[
                                        { text: 'One', value: 1 },
                                        { text: 'Two', value: 2 },
                                    ]}
                                /></td>
                                <td><MDBSelect
                                    data={[
                                        { text: 'One', value: 1 },
                                        { text: 'Two', value: 2 },
                                    ]}
                                /></td>
                                <td><MDBInput label='Example label' id='form1' type='text' /></td>
                                <td><MDBInput label='Example label' id='form1' type='text' /></td>
                                <td><MDBSelect
                                    data={[
                                        { text: 'One', value: 1 },
                                        { text: 'Two', value: 2 },
                                    ]}
                                /></td>
                                <td className="text-center w-5"><MDBIcon fas icon="times" color="primary" /></td>
                            </tr>
                            <tr className="table2 w-100 d-flex align-items-center justify-content-between w-100 py-1">
                                <td className="w-5"><MDBIcon fas icon="link" color="primary" className="me-2 ms-4 fs-small" />5a</td>
                                <td><MDBSelect
                                    data={[
                                        { text: 'One', value: 1 },
                                        { text: 'Two', value: 2 },
                                    ]}
                                /></td>
                                <td><MDBSelect
                                    data={[
                                        { text: 'One', value: 1 },
                                        { text: 'Two', value: 2 },
                                    ]}
                                /></td>
                                <td><MDBInput label='Example label' id='form1' type='text' /></td>
                                <td><MDBInput label='Example label' id='form1' type='text' /></td>
                                <td><MDBSelect
                                    data={[
                                        { text: 'One', value: 1 },
                                        { text: 'Two', value: 2 },
                                    ]}
                                /></td>
                                <td className="text-center w-5"><MDBIcon fas icon="times" color="primary" /></td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </>
        ),
    },
    // {
    //     id: "item-6",
    //     content: <div className="sortable-item"><MDBCheckbox name='inlineCheck' id='inlineCheckbox6' value='option6' label='Available Agents' /></div>,
    // },
    // {
    //     id: "item-7",
    //     content: <div className="sortable-item"><MDBCheckbox name='inlineCheck' id='inlineCheckbox7' value='option7' label='Unavailable Agents' /></div>,
    // },
    // {
    //     id: "item-8",
    //     content: <div className="sortable-item"><MDBCheckbox name='inlineCheck' id='inlineCheckbox8' value='option8' label='Logged-Out Agents' /></div>,
    // },
];

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: "none",
    ...draggableStyle,
});

const getListStyle = (isDraggingOver) => ({

});

function DragPopup() {

    const [items, setItems] = useState([]);

    useEffect(() => {
        setItems(data);
    }, []);

    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }

        const reorderedItems = reorder(
            items,
            result.source.index,
            result.destination.index
        );

        console.log({ reorderedItems });
        setItems(reorderedItems);
    };


    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();

    const [basicActive, setBasicActive] = useState('tab1');

    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }

        setBasicActive(value);
    };


    return (
        <React.Fragment>
            <>
                <MainLinks active={2} />
                <Body
                    tablinks={2}
                    sublink={10}
                    content={
                        <>

                            <section className="mb-3">
                                <div className="card card-height">

                                    <div className="card-header py-3 px-0">
                                        <h5 className="mb-0 ">
                                            <MDBBreadcrumb>
                                                <MDBBreadcrumbItem>
                                                    <a href="/huntgroup">
                                                        <strong>{t("phoneSystem")}</strong>
                                                    </a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem active>
                                                    <a href="/pslanding">
                                                        <strong>{t("IPPhoneDevices")}</strong>
                                                    </a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem>
                                                    <a href="">
                                                        <strong> Sample</strong>
                                                    </a>
                                                </MDBBreadcrumbItem>

                                            </MDBBreadcrumb>
                                        </h5>
                                    </div>





                                    <div className="card-body px-0">


                                        <div className="mt-2 d-flex w-100 justify-content-between ipphone_column mb-3">

                                            <div className="pb-2">
                                                <h5 className=" ">
                                                    Jack Smith
                                                </h5>
                                                <p className="mt-1 text-secondary">
                                                    Software
                                                </p>
                                                <p className="mt-1 text-secondary">
                                                    Nick VVX601
                                                </p>
                                                <p className="mt-1   text-secondary">
                                                    Nick VVX601 : 0004F21F3434
                                                </p>
                                            </div>



                                            <div className="mt-2 d-flex w-50__btnalign  justify-content-around ipphone_column ">
                                                <div className="d-flex flex-column align-items-center ip_column">
                                                    <strong className="">{t("Online")}</strong>
                                                    <span className="green-dot mt-2"></span>
                                                </div>
                                                <div className="d-flex flex-column align-items-center ip_column">
                                                    <strong className="">{t("IPAddress")}</strong>
                                                    <span className="mt-1">64.68.252.189.51923</span>
                                                </div>
                                                <div className="d-flex flex-column align-items-center ip_column">
                                                    <strong className="">{t("ZeroTouchStatus")}</strong>
                                                    <span className="green-dot mt-2"></span>
                                                </div>
                                                <div className="d-flex flex-column align-items-center ip_column">
                                                    <strong className="">{t("SyncConfig")}</strong>
                                                    <img
                                                        src={syncIcon}
                                                        className="syncIcon cursor-pointer mt-1"
                                                        alt="Sync Icon"
                                                    ></img>
                                                </div>
                                                <div className="position-relative ip_replace_button">
                                                    <MDBBtn
                                                        className="reload-replace-btn reload-replace-icon ip_w100pr"
                                                    >
                                                        <span className="reload-replace ip_icon"></span>
                                                        <span> {t("replaceDevice")}</span>
                                                    </MDBBtn>
                                                </div>
                                            </div>
                                        </div>



                                        <MDBTabs className='mb-3'>
                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                                                    Settings
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab2')} active={basicActive === 'tab2'}>
                                                    Buttons
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                        </MDBTabs>

                                        <MDBTabsContent>
                                            <MDBTabsPane open={basicActive === 'tab1'}>
                                                {/* Tab 1 content */}
                                            </MDBTabsPane>
                                            <MDBTabsPane open={basicActive === 'tab2'}>
                                                {/* Tab 2 content */}

                                                <div className="w-100">

                                                    <div className="mt-3" id="checkboxSort">
                                                        <div id="sortable" data-mdb-sortable="sortable">
                                                            <div className="main_content">

                                                                <table className="table table-responsive">
                                                                    <tbody>
                                                                        <tr>
                                                                            <th className="w-10 text-center">Buttons</th>
                                                                            <th className="w-20">Feature</th>
                                                                            <th>User or Value</th>
                                                                            <th>Label</th>
                                                                            <th>Number Of Buttons</th>
                                                                            <th>Ring</th>
                                                                            <th className="text-center">Delete</th>
                                                                        </tr>
                                                                        <td colspan="7">

                                                                            <DragDropContext onDragEnd={onDragEnd}>
                                                                                <Droppable droppableId="droppable">
                                                                                    {(provided, snapshot) => (
                                                                                        <div
                                                                                            className="w-100"
                                                                                            {...provided.droppableProps}
                                                                                            ref={provided.innerRef}
                                                                                            style={getListStyle(snapshot.isDraggingOver)}
                                                                                        >
                                                                                            {items.map((item, index) => (
                                                                                                <Draggable key={item.id} draggableId={item.id} index={index}>
                                                                                                    {(provided, snapshot) => (
                                                                                                        <div
                                                                                                            ref={provided.innerRef}
                                                                                                            {...provided.draggableProps}
                                                                                                            {...provided.dragHandleProps}
                                                                                                            style={getItemStyle(
                                                                                                                snapshot.isDragging,
                                                                                                                provided.draggableProps.style
                                                                                                            )}
                                                                                                        >
                                                                                                            {item.content}
                                                                                                        </div>
                                                                                                    )}
                                                                                                </Draggable>
                                                                                            ))}
                                                                                            {provided.placeholder}
                                                                                        </div>
                                                                                    )}
                                                                                </Droppable>
                                                                            </DragDropContext>

                                                                        </td>
                                                                    </tbody>
                                                                </table>

                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>



                                            </MDBTabsPane>
                                        </MDBTabsContent>





                                        <div>

                                        </div>

                                    </div>
                                </div>
                            </section>


                        </>
                    }
                />
            </>

        </React.Fragment>
    )
}
export default DragPopup